import React from 'react';
import { Calendar, Phone, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { barbershopInfo, galleryImages } from '../data/mock';

const HeroSection = () => {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/6lo4p8n9_image.png"
          alt="NY Barbershop"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/85 via-slate-950/75 to-slate-950/95" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/60 to-transparent" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-1/4 right-10 w-32 h-32 border border-[#c9a962]/20 rotate-45 animate-pulse" />
      <div className="absolute bottom-1/4 left-10 w-24 h-24 border border-[#c9a962]/10 rotate-12" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" dir="rtl">
        {/* Logo Badge */}
        <div className="inline-flex items-center justify-center mb-8 animate-fade-in">
          <div className="relative">
            <div className="w-24 h-24 sm:w-32 sm:h-32 border-2 border-[#c9a962] flex items-center justify-center bg-slate-950/50 backdrop-blur-sm">
              <span className="text-[#c9a962] font-bold text-3xl sm:text-4xl tracking-wider">NY</span>
            </div>
            <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-slate-950 px-4">
              <span className="text-[#c9a962] text-xs tracking-[0.4em] uppercase">Barbershop</span>
            </div>
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          <span className="block">תספורות</span>
          <span className="block text-[#c9a962]">בהתאמה אישית</span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl md:text-2xl text-slate-300 mb-4 max-w-2xl mx-auto">
          {barbershopInfo.owner}
        </p>
        <p className="text-base sm:text-lg text-slate-400 mb-10 max-w-xl mx-auto">
          יחס אישי | מקצועיות | תוצאה מובטחת
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href={barbershopInfo.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-[#c9a962] hover:bg-[#b8962f] text-slate-950 font-bold text-lg px-8 py-6 transition-all duration-300 hover:shadow-xl hover:shadow-[#c9a962]/30 hover:-translate-y-1">
              <Calendar className="w-5 h-5 ml-2" />
              הזמן תור עכשיו
            </Button>
          </a>
          <a href={`tel:${barbershopInfo.phone}`}>
            <Button
              variant="outline"
              className="border-2 border-[#c9a962]/50 text-[#c9a962] hover:bg-[#c9a962]/10 font-semibold text-lg px-8 py-6 transition-all duration-300"
            >
              <Phone className="w-5 h-5 ml-2" />
              {barbershopInfo.phone}
            </Button>
          </a>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={scrollToAbout}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#c9a962]/70 hover:text-[#c9a962] transition-colors animate-bounce"
        >
          <ChevronDown className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
